module.exports = "/_next/static/images/crisscross_morning-0812cf72fc5a715971a25dd4e87a72f8.jpg";